// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__1e5Hf","logo":"NavBar_logo__1JCri"};